import { render, staticRenderFns } from "./UITimg.vue?vue&type=template&id=4dc41f61"
import script from "./UITimg.vue?vue&type=script&lang=js"
export * from "./UITimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports